import React, {useState, useEffect} from 'react';
import {AiFillStar} from 'react-icons/ai';
import {useSelector} from 'react-redux';
import {notifyError, notifySuccess} from '../utils/toastError';
import Loader from './Loader';

const style = {
  numberItemDiv: 'px-3 py-1 bg-gray-900 border-2 border-lyellow font-bold text-lyellow rounded-xl',
  numberItemInput: 'outline-none bg-transparent w-8 h-10 text-2xl text-center',
  starItem: 'text-[#FFD700] text-3xl relative z-50 left-[2.5em] bottom-4',
  buttonStyle: 'bg-lyellow text-md font-semibold py-3 px-[5em] hover:bg-[#1d2226] hover:text-white transition ease-in duration-50 rounded-lg',
  modalWrapper: 'justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none bg-black/60',
};

const ModalDrawPick = ({setShowModalDrawPick, showModalDrawPick}) => {
  const [userNumbers, setUserNumbers] = useState ({
    number1: '',
    number2: '',
    number3: '',
    number4: '',
    number5: '',
  });
  const [userStar, setUserStar] = useState ({star1: '', star2: ''});
  const {connect, lotteryContract, tuesdayContract} = useSelector (
    state => state.provider
  );
  const [loader, setLoader] = useState (false);
  const [tickets, setTickets] = useState (0);

  const {both, tuesday, friday,tuesdayTime,fridayTime} = useSelector (state => state.lotteryDay);

  useEffect (
    () => {
      if (showModalDrawPick) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    },
    [showModalDrawPick]
  );

  useEffect (
    () => {
      if (connect) {
        fetchTickets ();
      }
    },
    [connect,  showModalDrawPick]
  );

  const fetchTickets = async () => {
    let ticketsInfo = 0;
    if (both) {
      if (parseInt(tuesdayTime)< parseInt(fridayTime)) {
          //tuesday
          ticketsInfo = await tuesdayContract.getTotalBuyTickets ();
        } else {
        //friday
        ticketsInfo = await lotteryContract.getTotalBuyTickets ();
      }
    } else {
      if (tuesday) {
        ticketsInfo = await tuesdayContract.getTotalBuyTickets ();
      } else {
        ticketsInfo = await lotteryContract.getTotalBuyTickets ();
      }
    }
    console.log (ticketsInfo.toString (), 'ticketsInfo');
    setTickets (ticketsInfo.toString ());
  };

  const handleChangeNumber = e => {
    e.preventDefault ();
    const exst = Object.values (userNumbers).includes (e.target.value);
    // console.log ('exst', exst);
    setUserNumbers ({...userNumbers, [e.target.name]: e.target.value});
  };

  const handleChangeStar = e => {
    e.preventDefault ();
    setUserStar ({...userStar, [e.target.name]: e.target.value});
  };

  const addGuess = async () => {
    // has entered 5 numbers
    if (Object.values (userNumbers).includes ('')) {
      notifyError ('Please enter 5 numbers');
      return;
    }
    // has entered 2 stars
    if (Object.values (userStar).includes ('')) {
      notifyError ('Please enter 2 stars');
      return;
    }
    //  numbers 1-50
    if (Object.values (userNumbers).some (num => num < 1 || num > 50)) {
      notifyError ('Please enter numbers between 1-50');
      return;
    }
    //  stars 1-12
    if (Object.values (userStar).some (num => num < 1 || num > 12)) {
      notifyError ('Please enter stars between 1-12');
      return;
    }
    // numbers  not repeated
    if (
      Object.values (userNumbers).some (
        num => Object.values (userNumbers).filter (n => n === num).length > 1
      )
    ) {
      notifyError ('Please enter unique numbers');
      return;
    }
    // stars not repeated
    if (
      Object.values (userStar).some (
        num => Object.values (userStar).filter (n => n === num).length > 1
      )
    ) {
      notifyError ('Please enter unique stars');
      return;
    }

    if (both) {
      if (parseInt(tuesdayTime)<parseInt(fridayTime)) {
        //tuesday
        addGuessToContract(tuesdayContract);
      } else {
        //friday
        addGuessToContract(lotteryContract);
      }
    } else {
      if (tuesday) {
        addGuessToContract(tuesdayContract);
      } else {
        addGuessToContract(lotteryContract);
      }
    }
  };

  const addGuessToContract = async (contract) => {
    if (connect) {
      setLoader (true);
      try {
        await contract.functions
          .addGuessNumber (
            userNumbers.number1,
            userNumbers.number2,
            userNumbers.number3,
            userNumbers.number4,
            userNumbers.number5,
            userStar.star1,
            userStar.star2
          )
          .then (tx => {
            return tx.wait (1).then (receipt => {
              console.log ('Transaction receipt:', receipt);
              setLoader (false);
              fetchTickets ();
              notifySuccess ('Your Guess Number Is Added Successfully');
              setUserNumbers ({
                number1: '',
                number2: '',
                number3: '',
                number4: '',
                number5: '',
              });
              setUserStar ({star1: '', star2: ''});
              setShowModalDrawPick (false);
            }), error => {
              return error.checkCall ().then (error => {
                console.log ('Error', error);
                setLoader (false);
                notifyError (error.message);
              });
            };
          });
      } catch (error) {
        setLoader (false);
        if (error.reason) {
          console.log (error.reason);
          notifyError (error.reason);
        } else {
          console.log (error.message);
          notifyError (error.message);
        }
      }
    } else {
      notifyError ('Please Connect Metamask Wallet');
    }
  };

  const addRandom = () => {
    const randomNumbers = {};
    const randomStars = {};
    for (let i = 1; i <= 5; i++) {
      randomNumbers[`number${i}`] = Math.floor (Math.random () * 50) + 1;
    }
    for (let i = 1; i <= 2; i++) {
      randomStars[`star${i}`] = Math.floor (Math.random () * 12) + 1;
    }
    setUserNumbers (randomNumbers);
    setUserStar (randomStars);
  };

  return (
    <div>
      {showModalDrawPick
        ? <div>
            <div className={style.modalWrapper}>
              <div className="relative my-6 mx-auto w-[25em] sm:w-[35em] rounded-xl">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-black outline-none focus:outline-none">
                  {/*header*/}
                  <div className="flex items-center justify-between p-5 border-b border-solid border-lyellow rounded-t text-lyellow">
                    <h3 className="text-2xl font-semibold">
                      Pick Your Lucky Numbers & Stars
                    </h3>
                    <div className="flex justify-center items-center text-white outline-none focus:outline-none text-xl mx-2">
                      <button
                        className="text-lyellow"
                        onClick={() => setShowModalDrawPick (false)}
                      >
                        X
                      </button>
                    </div>
                  </div>
                  {/*body*/}
                  <div className="pt-3 pl-5">
                    <p className="text-lyellow text-lg font-semibold text-center">
                      Numbers Of Tickets You Have
                      {' '}
                      <span className="text-green-600 font-bold text-xl ml-1">
                        {' '}{tickets}
                      </span>
                      {' '}
                    </p>
                  </div>
                  <div className="relative p-5 flex-auto text-lyellow flex items-center justify-center flex-col">
                    <div className="flex items-center flex-col gap-y-5">
                      <div className="flex items-center flex-col my-2">
                        <p className="text-3xl font-semibold tracking-wide">
                          Numbers
                        </p>
                        <p className="text-xs text-red-500 font-semibold">
                          Must be unique and between 1-50
                        </p>
                      </div>
                      <div className="flex gap-x-4">
                        <div className={style.numberItemDiv}>
                          <input
                            type="text"
                            maxLength={2}
                            className={style.numberItemInput}
                            name="number1"
                            value={userNumbers.number1}
                            onChange={handleChangeNumber}
                          />
                        </div>
                        <div className={style.numberItemDiv}>
                          <input
                            type="text"
                            maxLength={2}
                            className={style.numberItemInput}
                            name="number2"
                            value={userNumbers.number2}
                            onChange={handleChangeNumber}
                          />
                        </div>
                        <div className={style.numberItemDiv}>
                          <input
                            type="text"
                            maxLength={2}
                            className={style.numberItemInput}
                            name="number3"
                            value={userNumbers.number3}
                            onChange={handleChangeNumber}
                          />
                        </div>
                        <div className={style.numberItemDiv}>
                          <input
                            type="text"
                            maxLength={2}
                            className={style.numberItemInput}
                            name="number4"
                            value={userNumbers.number4}
                            onChange={handleChangeNumber}
                          />
                        </div>
                        <div className={style.numberItemDiv}>
                          <input
                            type="text"
                            maxLength={2}
                            className={style.numberItemInput}
                            name="number5"
                            value={userNumbers.number5}
                            onChange={handleChangeNumber}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center flex-col gap-y-5 mt-6">
                      <div className="flex items-center flex-col my-2">
                        <p className="text-3xl font-semibold tracking-wide">
                          Stars
                        </p>
                        <p className="text-xs text-red-500 font-semibold">
                          Must be unique and in range of 1-12
                        </p>
                      </div>

                      <div className="flex relative right-4">
                        <div className="flex">
                          <AiFillStar className={style.starItem} />
                          <div className={style.numberItemDiv}>
                            <input
                              type="text"
                              maxLength={2}
                              className={style.numberItemInput}
                              name="star1"
                              value={userStar.star1}
                              onChange={handleChangeStar}
                            />
                          </div>
                        </div>
                        <div className="flex">
                          <AiFillStar className={style.starItem} />
                          <div className={style.numberItemDiv}>
                            <input
                              type="text"
                              maxLength={2}
                              className={style.numberItemInput}
                              name="star2"
                              value={userStar.star2}
                              onChange={handleChangeStar}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*footer*/}
                  <div className="flex flex-col items-center justify-center p-6 border-t border-solid border-lyellow rounded-b text-black gap-y-5">
                    <button className={style.buttonStyle} onClick={addRandom}>
                      Randomize
                    </button>
                    <button
                      className={style.buttonStyle.concat (' px-[5.7em]')}
                      onClick={addGuess}
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
              <div className="absolute w-full bg-black/30">
                {loader ? <Loader /> : null}
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black" />
          </div>
        : null}
    </div>
  );
};

export default ModalDrawPick;
